export default __webpack_public_path__ + "static/media/iconairquality.f0bd1610.svg";